import React from 'react'
import BuyCryptoComp from '../../components/blog/BuyCryptoComp'

const BuyCrypto = () => {
    return (
        <>
            <BuyCryptoComp />
        </>
    )
}

export default BuyCrypto